import { PawMark } from '#app/root.tsx'
import { cn } from '#app/utils/misc.tsx'

/**
 * The chromeless front-door card (plan §2.3, ADR-027): the 404 door on
 * /week/:token and the name+code login on /week/login. One card, the Oyka
 * mark, a title and whatever the door says; styles in oy.css (`.oy-door`).
 * The Stal-app and Oyka voor Else keep their own doors (StalClosedDoor,
 * ElseDoor) because their brand tile and scale differ.
 */
export function OyDoor({
	title,
	children,
	className,
}: {
	title: string
	children: React.ReactNode
	className?: string
}) {
	return (
		<main className={cn('oy oy-door', className)}>
			<div className="oy-door-card">
				<span className="oy-door-mark" aria-hidden="true">
					<PawMark className="size-6" />
				</span>
				<h1>{title}</h1>
				{children}
			</div>
		</main>
	)
}
